__turbopack_context__.v({
  "scale": "TlNOYW_scale",
  "scale--pending": "TlNOYW_scale--pending",
});
